 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientOpportunityTravelTypeAddEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// $('.client-opportunity-travel-types-add-edit .travel-type-value').on('change', function click(e)
		// {
		// 	Adzuki.Form.forceFloat($(this));
		// });
	};

	form.success = function success(response)
	{
		var $form_jqo      = $('form[name="' + form.name + '"]'),
		    opportunity_id = $form_jqo.data('opportunity-id');

		if (!Adzuki.Form.hasError(response)) {
			// reload projections box
			Adzuki.Ajax.get('/ClientOpportunityTravelTypes/ajaxReloadList/' + opportunity_id)
			.then(function populate(content) {

				// success message
				Adzuki.StatusMessage('Success', 'Successfully saved travel type');

				// replace follow-ups list
				$('#client_opportunity_travel_types').replaceWith(content);

				// close right sidebar
				Adzuki.Sidebar.toggleRightSidebar('off');
			});
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving travel type');
		return false;
	};

}(jQuery, window.Adzuki || {}));
